import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  private readonly captchaLength = 6;

  generateCaptcha(): string {
    const chars = 'ABCDEFGHJKMNOPQRSTUVWXYZabcdefghjkmnopqrstuvwxyz0123456789'; //'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let captcha = '';
    for (let i = 0; i < this.captchaLength; i++) {
      const randomChar = chars.charAt(Math.floor(Math.random() * chars.length));
      captcha += randomChar;
    }
    return captcha;
  }

  validateCaptcha(input: string, captcha: string): boolean {
    return input === captcha;
  }
}
